module.exports = __webpack_public_path__ + "img/6.326ec14b.jpeg";